module.exports = __webpack_public_path__ + "static/media/hotdog.6b49f376.mp3";